import styled, { keyframes } from "styled-components";
import { Button } from "components";

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(31, 32, 33, 0.85);
	backdrop-filter: blur(8px);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 90000;
	animation: ${fadeIn} 0.3s ease-out;
	padding: 20px;
`;

export const ModalCard = styled.div`
	background: ${({ theme }) => theme.colors.primaryWhite};
	border-radius: 16px;
	padding: 48px 40px;
	max-width: 480px;
	width: 100%;
	text-align: center;
	box-shadow: 0 24px 48px rgba(0, 0, 0, 0.2);
	position: relative;

	@media screen and (max-width: 500px) {
		padding: 32px 24px;
	}
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 16px;
	right: 16px;
	width: 32px;
	height: 32px;
	border: none;
	background: transparent;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: background-color 0.2s;

	&:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	svg {
		width: 20px;
		height: 20px;
		color: ${({ theme }) => theme.colors.secondaryGrey};
	}
`;

export const IconWrapper = styled.div`
	width: 80px;
	height: 80px;
	margin: 0 auto 24px;
	background: ${({ theme }) => theme.colors.opacityRed10};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: 40px;
		height: 40px;
		color: ${({ theme }) => theme.colors.secondaryRed};
	}
`;

export const Title = styled.h2`
	color: ${({ theme }) => theme.colors.primaryBlack};
	font-size: 24px;
	font-weight: ${({ theme }) => theme.fontWeights.boldFontWeight};
	margin: 0 0 12px 0;
`;

export const Description = styled.p`
	color: ${({ theme }) => theme.colors.secondaryGrey};
	font-size: ${({ theme }) => theme.fontSizes.body1FontSize};
	line-height: 1.6;
	margin: 0 0 24px 0;
`;

export const PayButton = styled(Button)`
	white-space: nowrap;
	cursor: pointer;
	flex-shrink: 0;
	height: 48px;
	border-radius: 10px;
	padding: 16px 36px;
	font-size: 0.875em;
	width: 100%;

	&:disabled {
		opacity: 0.7;
		background-color: #4AC365;
		cursor: not-allowed;
		pointer-events: auto;
	}
`;

export const Price = styled.div`
	color: ${({ theme }) => theme.colors.primaryBlack};
	font-size: 32px;
	font-weight: ${({ theme }) => theme.fontWeights.boldFontWeight};
	margin-bottom: 24px;

	span {
		color: ${({ theme }) => theme.colors.secondaryGrey};
		font-size: 16px;
		font-weight: ${({ theme }) => theme.fontWeights.normalFontWeight};
	}
`;

export const CheckboxGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 20px;
	text-align: left;
`;

export const CheckboxWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	font-size: 13px;
	color: ${({ theme }) => theme.colors.secondaryGrey};
	line-height: 1.4;
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
	appearance: none;
	-webkit-appearance: none;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	margin-top: 2px;
	cursor: pointer;
	border: 2px solid ${({ theme }) => theme.colors.primaryGreen};
	border-radius: 4px;
	background-color: transparent;
	position: relative;

	&:checked {
		background-color: ${({ theme }) => theme.colors.primaryGreen};
	}

	&:checked::after {
		content: "";
		position: absolute;
		left: 4px;
		top: 1px;
		width: 4px;
		height: 8px;
		border: solid white;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}
`;

export const CheckboxText = styled.span`
	a {
		color: ${({ theme }) => theme.colors.primaryGreen};
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
`;

